import { MdxDiv } from '@features/mdx/MdxDiv';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '2ea08d75-43ee-4ee5-aa55-7681112f37be',
	[LanguageEnum.SK]: '2ea08d75-43ee-4ee5-aa55-7681112f37be',
	default: '2ea08d75-43ee-4ee5-aa55-7681112f37be'
}


export const TextBox = () => {

	return (
		<MdxDiv className='text-box' articleIds={articleIds}>
		</MdxDiv>
	);
};